import React from "react";
import ContactUsform from "./contactUs";

const CollegeAddressContact = () => {
  return (
    <div
      className="relative py-20 px-4"
      style={{
        background:
          "linear-gradient(135deg, #eef2ff 0%, #f8fafc 50%, #e0f2fe 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center flex flex-col md:flex-row">

        {/* LEFT CONTENT */}
        <div className="space-y-8">

          <div>
            <h2 className="text-4xl font-bold text-gray-800 leading-tight">
              Visit Our Campus
            </h2>
            <p className="text-gray-600 mt-4 text-lg">
              Sri Ramanujar Engineering College is located in a peaceful
              environment at Vandalur, Chennai. Reach us easily through the
              map or contact us directly.
            </p>
          </div>

          {/* Map Card */}
          <div className="rounded-3xl overflow-hidden shadow-2xl border border-white/40 backdrop-blur-lg">
            <iframe
              title="College Address"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.6605565325303!2d80.1107810756295!3d12.865187217201242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52589404780505%3A0x9e77d9840f606368!2sSri%20Ramanujar%20Engineering%20College!5e0!3m2!1sen!2sin!4v1707571774926!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>

        </div>

        {/* RIGHT SIDE CONTACT CARD */}
        <div className="flex justify-center">
          <ContactUsform />
        </div>

      </div>
    </div>
  );
};

export default CollegeAddressContact;